import { apiDelete, apiGet, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "CHANGE_REQUESTS";

const ActionTypes = {
  getOriginalClientChangeRequest: `${NAMESPACE}/GET_ORIGINAL_CLIENT_CHANGE_REQUEST`,
  getClientChangeRequests: `${NAMESPACE}/GET_CLIENT_CHANGE_REQUESTS`,
  getClientChangeRequest: `${NAMESPACE}/GET_CLIENT_CHANGE_REQUEST`,
  approveClientChangeRequest: `${NAMESPACE}/APPROVE_CLIENT_CHANGE_REQUEST`,
  rejectClientChangeRequest: `${NAMESPACE}/REJECT_CLIENT_CHANGE_REQUEST`,
  deleteClientChangeRequest: `${NAMESPACE}/DELETE_CLIENT_CHANGE_REQUEST`,
};

export const getClientChangeRequests = (_, { clientId }) => {
  return apiGet(
    ActionTypes.getClientChangeRequests,
    `clients/${clientId}/change-requests`,
  );
};

export const getOriginalClientChangeRequest = ({ requestId, clientId }) => {
  return apiGet(
    ActionTypes.getOriginalClientChangeRequest,
    `clients/change-request/${requestId}/original/${clientId}`,
  );
};

export const getClientChangeRequest = ({ requestId }) => {
  return apiGet(
    ActionTypes.getClientChangeRequest,
    `clients/change-request/${requestId}`,
  );
};

export const approveClientChangeRequest = (requestId) => {
  return apiPut(
    ActionTypes.approveClientChangeRequest,
    `clients/change-request/${requestId}/approve`,
  );
};

export const rejectClientChangeRequest = (requestId, reason) => {
  return apiPut(
    ActionTypes.rejectClientChangeRequest,
    `clients/change-request/${requestId}/reject`,
    { reason },
  );
};

export const deleteClientChangeRequest = (requestId) => {
  return apiDelete(
    ActionTypes.deleteClientChangeRequest,
    `clients/change-request/${requestId}`,
  );
};
